/* Bloom & Banner product illustrations (assets/bb-art.js).
   Draws the builder previews as SVG from the customer's choices, modelled on
   the studio's own photos: a white chrysanthemum crown inside a ring of looped
   ribbon, a skirt of V-cut satin ribbons, braids, name ribbons, charms, a bell,
   and satin roses. Garters use the same parts, smaller. Leis are a braided
   satin strand with roses and daisies.

   BBArt.mum(opts), BBArt.garter(opts), BBArt.lei(opts) each return an <svg> string.
   Everything is seeded, so the same choices always draw the same picture. */
(function (root) {
  'use strict';
  var uid = 0;

  // ---------- color helpers ----------
  function hex2rgb(h) {
    h = String(h || '#ffffff').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function rgb2hex(c) {
    return '#' + c.map(function (v) { v = Math.max(0, Math.min(255, Math.round(v))); return (v < 16 ? '0' : '') + v.toString(16); }).join('');
  }
  function mix(a, b, t) { var x = hex2rgb(a), y = hex2rgb(b); return rgb2hex([0, 1, 2].map(function (i) { return x[i] + (y[i] - x[i]) * t; })); }
  function lum(h) { var c = hex2rgb(h).map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }); return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]; }
  function hsl(h) {
    var c = hex2rgb(h).map(function (v) { return v / 255; }), mx = Math.max.apply(0, c), mn = Math.min.apply(0, c), l = (mx + mn) / 2, s = 0, hh = 0, d = mx - mn;
    if (d) { s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn); hh = mx === c[0] ? (c[1] - c[2]) / d + (c[1] < c[2] ? 6 : 0) : mx === c[1] ? (c[2] - c[0]) / d + 2 : (c[0] - c[1]) / d + 4; hh *= 60; }
    return [hh, s, l];
  }
  function isGoldish(h) { var x = hsl(h); return x[0] > 28 && x[0] < 58 && x[1] > 0.35 && x[2] > 0.3 && x[2] < 0.75; }
  function isWhitish(h) { return lum(h) > 0.82; }

  // ---------- seeded random ----------
  function rng(seed) { var a = seed >>> 0; return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function f(n) { return Math.round(n * 10) / 10; }

  // ---------- defs (gradients) ----------
  function Defs(id) { this.id = id; this.items = {}; this.n = 0; }
  Defs.prototype.satin = function (c) { // horizontal sheen across a ribbon
    var k = 'sat' + c; if (this.items[k]) return this.items[k].ref;
    var g = this.id + 's' + (this.n++), white = isWhitish(c);
    var lo = mix(c, '#000000', white ? 0.12 : 0.28), hi = mix(c, '#ffffff', white ? 0.6 : 0.32);
    this.items[k] = { ref: 'url(#' + g + ')', svg: '<linearGradient id="' + g + '" x1="0" x2="1" y1="0" y2="0"><stop offset="0" stop-color="' + lo + '"/><stop offset=".22" stop-color="' + c + '"/><stop offset=".46" stop-color="' + hi + '"/><stop offset=".62" stop-color="' + c + '"/><stop offset="1" stop-color="' + mix(c, '#000000', white ? 0.16 : 0.34) + '"/></linearGradient>' };
    return this.items[k].ref;
  };
  Defs.prototype.metal = function (c) { // banded metallic, used for gold and silver accents
    var k = 'met' + c; if (this.items[k]) return this.items[k].ref;
    var g = this.id + 'm' + (this.n++), d = mix(c, '#000000', 0.38), l = mix(c, '#ffffff', 0.55);
    this.items[k] = { ref: 'url(#' + g + ')', svg: '<linearGradient id="' + g + '" x1="0" x2="1" y1="0" y2=".25"><stop offset="0" stop-color="' + d + '"/><stop offset=".18" stop-color="' + l + '"/><stop offset=".34" stop-color="' + c + '"/><stop offset=".52" stop-color="' + d + '"/><stop offset=".7" stop-color="' + l + '"/><stop offset="1" stop-color="' + c + '"/></linearGradient>' };
    return this.items[k].ref;
  };
  Defs.prototype.radial = function (c, key) { // loop shading in the crown ring: darker toward the flower
    var k = 'rad' + c + key; if (this.items[k]) return this.items[k].ref;
    var g = this.id + 'r' + (this.n++);
    this.items[k] = { ref: 'url(#' + g + ')', svg: '<linearGradient id="' + g + '" x1="0" x2="0" y1="1" y2="0"><stop offset="0" stop-color="' + mix(c, '#000000', isWhitish(c) ? 0.2 : 0.38) + '"/><stop offset=".55" stop-color="' + c + '"/><stop offset=".86" stop-color="' + mix(c, '#ffffff', 0.3) + '"/><stop offset="1" stop-color="' + c + '"/></linearGradient>' };
    return this.items[k].ref;
  };
  Defs.prototype.petal = function () {
    var k = 'petal'; if (this.items[k]) return this.items[k].ref;
    var g = this.id + 'p';
    this.items[k] = { ref: 'url(#' + g + ')', svg: '<linearGradient id="' + g + '" x1="0" x2="0" y1="1" y2="0"><stop offset="0" stop-color="#cfc8c0"/><stop offset=".45" stop-color="#efebe6"/><stop offset="1" stop-color="#ffffff"/></linearGradient>' };
    return this.items[k].ref;
  };
  Defs.prototype.out = function () {
    var s = '<defs><filter id="' + this.id + 'sh" x="-20%" y="-20%" width="140%" height="140%"><feDropShadow dx="0" dy="1.6" stdDeviation="1.8" flood-color="#2a2018" flood-opacity=".22"/></filter>';
    s += '<radialGradient id="' + this.id + 'fc"><stop offset="0" stop-color="#b9ad9f" stop-opacity=".28"/><stop offset="1" stop-color="#b9ad9f" stop-opacity="0"/></radialGradient>';
    for (var k in this.items) s += this.items[k].svg;
    return s + '</defs>';
  };

  // ---------- palette from the customer's colors ----------
  function palette(colors) {
    var cs = (colors || []).filter(Boolean);
    if (!cs.length) cs = ['#1F3A93', '#C9A227'];
    var p = cs[0], s = cs[1] || (isWhitish(p) ? '#9AA0A6' : '#FFFFFF'), t = cs[2] || '#FFFFFF', q = cs[3] || null;
    var gold = cs.filter(isGoldish)[0];
    var metal = gold || (isWhitish(p) && isWhitish(s) ? '#C9A227' : '#B9BEC4'); // gold if the school has it, else silver
    return { p: p, s: s, t: t, q: q, metal: metal, all: cs };
  }

  // ---------- parts ----------
  // A straight satin ribbon hanging from (x, y), with a V-cut or angled end.
  function ribbon(d, x, y, w, len, c, o) {
    o = o || {};
    var yb = y + len, cut = o.cut === 'angle' ? 'M' + f(x) + ' ' + f(y) + 'H' + f(x + w) + 'V' + f(yb - w * 0.55) + 'L' + f(x) + ' ' + f(yb) + 'Z'
      : 'M' + f(x) + ' ' + f(y) + 'H' + f(x + w) + 'V' + f(yb) + 'L' + f(x + w / 2) + ' ' + f(yb - Math.min(w * 0.55, 14)) + 'L' + f(x) + ' ' + f(yb) + 'Z';
    var fill = o.metal ? d.metal(c) : d.satin(c), s = '<g' + (o.rot ? ' transform="rotate(' + f(o.rot) + ' ' + f(x + w / 2) + ' ' + f(y) + ')"' : '') + '>';
    s += '<path d="' + cut + '" fill="' + fill + '" stroke="' + mix(c, '#000000', 0.35) + '" stroke-opacity=".28" stroke-width=".6"/>';
    if (o.edge) s += '<rect x="' + f(x + 1.2) + '" y="' + f(y) + '" width="1.6" height="' + f(len - w * 0.6) + '" fill="' + o.edge + '"/><rect x="' + f(x + w - 2.8) + '" y="' + f(y) + '" width="1.6" height="' + f(len - w * 0.6) + '" fill="' + o.edge + '"/>';
    if (o.stripe) s += '<rect x="' + f(x + w / 2 - o.stripeW / 2) + '" y="' + f(y) + '" width="' + f(o.stripeW) + '" height="' + f(len - w * 0.6) + '" fill="' + o.stripe + '"/>';
    if (o.glitter) { var r = rng(Math.round(x * 7 + y)); for (var i = 0; i < len / 3; i++) s += '<circle cx="' + f(x + 1 + r() * (w - 2)) + '" cy="' + f(y + r() * (len - w * 0.7)) + '" r=".55" fill="#fff" opacity="' + f(0.35 + r() * 0.5) + '"/>'; }
    if (o.inner) s += o.inner;
    return s + '</g>';
  }

  // Braids, drawn as a column from (x, y), width w, length len.
  function braid(d, style, x, y, w, len, c1, c2, metal) {
    var s = '<g>', step, i, yy, cx = x + w / 2;
    var dark1 = mix(c1, '#000000', 0.3), dark2 = mix(c2, '#000000', 0.3);
    var ln = ' stroke="#000" stroke-opacity=".18" stroke-width=".5"';
    if (style === 'loop' || style === 'triple' || style === 'mobius' || style === 'heart') {
      // loop chains: ribbon loops stacked down a center line
      step = style === 'triple' ? 9 : 11;
      for (yy = y, i = 0; yy < y + len - 6; yy += step, i++) {
        var side = i % 2 ? 1 : -1, col = i % 2 ? c2 : c1;
        if (style === 'heart') {
          s += '<path d="M' + f(cx) + ' ' + f(yy + 9) + 'C' + f(cx - w * 0.62) + ' ' + f(yy + 2) + ' ' + f(cx - w * 0.34) + ' ' + f(yy - 5) + ' ' + f(cx) + ' ' + f(yy + 1) + 'C' + f(cx + w * 0.34) + ' ' + f(yy - 5) + ' ' + f(cx + w * 0.62) + ' ' + f(yy + 2) + ' ' + f(cx) + ' ' + f(yy + 9) + 'Z" fill="none" stroke="' + col + '" stroke-width="3.2"/>';
        } else {
          var rx = style === 'mobius' ? w * 0.5 : w * 0.42, ry = step * 0.85;
          s += '<ellipse cx="' + f(cx + side * w * (style === 'triple' ? 0.12 : 0.06)) + '" cy="' + f(yy + ry * 0.6) + '" rx="' + f(rx) + '" ry="' + f(ry) + '" fill="none" stroke="' + mix(col, '#000000', 0.25) + '" stroke-width="3.6"/>';
          s += '<ellipse cx="' + f(cx + side * w * (style === 'triple' ? 0.12 : 0.06)) + '" cy="' + f(yy + ry * 0.6) + '" rx="' + f(rx) + '" ry="' + f(ry) + '" fill="none" stroke="' + mix(col, '#ffffff', 0.18) + '" stroke-width="2.2"/>';
          if (style === 'mobius') s += '<path d="M' + f(cx - rx * 0.7) + ' ' + f(yy + ry * 0.2) + 'Q' + f(cx) + ' ' + f(yy + ry * 1.4) + ' ' + f(cx + rx * 0.7) + ' ' + f(yy + ry * 0.2) + '" fill="none" stroke="' + mix(col, '#ffffff', 0.25) + '" stroke-width="1.6"/>';
        }
      }
    } else if (style === 'box' || style === 'texas' || style === 'diamond' || style === 'triangle') {
      // woven braids: a checker of folded squares, diamonds, or triangles
      var cell = w / 2;
      for (yy = y, i = 0; yy < y + len - cell; yy += cell, i++) {
        for (var j = 0; j < 2; j++) {
          var col2 = (i + j) % 2 ? c2 : c1, xx = x + j * cell;
          if (style === 'diamond') s += '<path d="M' + f(xx + cell / 2) + ' ' + f(yy) + 'L' + f(xx + cell) + ' ' + f(yy + cell / 2) + 'L' + f(xx + cell / 2) + ' ' + f(yy + cell) + 'L' + f(xx) + ' ' + f(yy + cell / 2) + 'Z" fill="' + d.satin(col2) + '"' + ln + '/>';
          else if (style === 'triangle') s += '<path d="M' + f(xx) + ' ' + f(yy + cell) + 'L' + f(xx + cell / 2) + ' ' + f(yy) + 'L' + f(xx + cell) + ' ' + f(yy + cell) + 'Z" fill="' + d.satin(col2) + '"' + ln + '/>';
          else s += '<rect x="' + f(xx) + '" y="' + f(yy) + '" width="' + f(cell) + '" height="' + f(cell) + '" fill="' + d.satin(col2) + '"' + ln + '/><path d="M' + f(xx) + ' ' + f(yy + cell) + 'L' + f(xx + cell) + ' ' + f(yy) + '" stroke="#fff" stroke-opacity=".25" stroke-width=".8"/>';
        }
        if (style === 'texas') s += '<rect x="' + f(cx - 0.8) + '" y="' + f(yy) + '" width="1.6" height="' + f(cell) + '" fill="' + metal + '"/>';
      }
    } else if (style === 'ruffle' || style === 'druffle') {
      // ruffles: folded ribbon zigzagging side to side
      step = 6;
      for (yy = y, i = 0; yy < y + len - 6; yy += step, i++) {
        var col3 = style === 'druffle' && i % 2 ? c2 : c1;
        s += '<path d="M' + f(x) + ' ' + f(yy) + 'Q' + f(cx) + ' ' + f(yy + (i % 2 ? 9 : -2)) + ' ' + f(x + w) + ' ' + f(yy) + 'L' + f(x + w) + ' ' + f(yy + step + 1) + 'Q' + f(cx) + ' ' + f(yy + step + (i % 2 ? 10 : -1)) + ' ' + f(x) + ' ' + f(yy + step + 1) + 'Z" fill="' + d.satin(col3) + '"' + ln + '/>';
      }
    } else if (style === 'whip') {
      // whip braid: a twisted rope of diagonal bands
      s += '<rect x="' + f(x) + '" y="' + f(y) + '" width="' + f(w) + '" height="' + f(len) + '" rx="' + f(w / 2) + '" fill="' + d.satin(c1) + '"/>';
      for (yy = y; yy < y + len - 8; yy += 8) s += '<path d="M' + f(x) + ' ' + f(yy + 6) + 'L' + f(x + w) + ' ' + f(yy) + 'L' + f(x + w) + ' ' + f(yy + 3.5) + 'L' + f(x) + ' ' + f(yy + 9.5) + 'Z" fill="' + c2 + '"/>';
    } else {
      // military braid (single or double): stacked chevrons
      step = style === 'double' ? 7 : 9;
      for (yy = y, i = 0; yy < y + len - step; yy += step, i++) {
        var col4 = i % 2 ? c2 : c1;
        s += '<path d="M' + f(x) + ' ' + f(yy) + 'L' + f(cx) + ' ' + f(yy + step * 0.75) + 'L' + f(x + w) + ' ' + f(yy) + 'L' + f(x + w) + ' ' + f(yy + step + 1) + 'L' + f(cx) + ' ' + f(yy + step * 1.75 + 1) + 'L' + f(x) + ' ' + f(yy + step + 1) + 'Z" fill="' + d.satin(col4) + '"' + ln + '/>';
      }
      if (style === 'double') s += '<rect x="' + f(cx - 0.9) + '" y="' + f(y) + '" width="1.8" height="' + f(len - 8) + '" fill="' + metal + '" opacity=".9"/>';
    }
    return s + '</g>';
  }

  // Name ribbon with lettering down its length.
  function nameRibbon(d, x, y, w, len, base, name, kind, ink) {
    var letters = String(name || '').toUpperCase().replace(/[^A-Z0-9&]/g, '').slice(0, 12) || 'NAME';
    var s = ribbon(d, x, y, w, len, base, { edge: kind === 'rhinestone' ? '#E8ECF0' : null });
    var gap = Math.min(15, (len - 24) / letters.length), cx = x + w / 2;
    for (var i = 0; i < letters.length; i++) {
      var cy = y + 12 + i * gap;
      if (kind === 'pearl') s += '<circle cx="' + f(cx) + '" cy="' + f(cy) + '" r="' + f(gap * 0.46) + '" fill="#FBF8F2" stroke="#C9C0B4" stroke-width=".7"/>';
      if (kind === 'rhinestone') s += '<circle cx="' + f(cx) + '" cy="' + f(cy) + '" r="' + f(gap * 0.46) + '" fill="#DDE3E8" stroke="#9AA4AD" stroke-width=".6"/>';
      s += '<text x="' + f(cx) + '" y="' + f(cy + gap * 0.3) + '" text-anchor="middle" font-family="Georgia,serif" font-weight="700" font-size="' + f(gap * 0.82) + '" fill="' + (kind ? '#3A332C' : ink) + '">' + letters[i] + '</text>';
    }
    return s;
  }

  // Ribbon with a printed word (Homecoming, Senior) running down it.
  function wordRibbon(d, x, y, w, len, base, word, ink) {
    var cx = x + w / 2, cy = y + 16, size = Math.min(w * 0.62, 9);
    var s = ribbon(d, x, y, w, len, base, {});
    s += '<text transform="translate(' + f(cx + size * 0.35) + ' ' + f(cy) + ') rotate(90)" font-family="Georgia,serif" font-style="italic" font-weight="700" font-size="' + f(size) + '" fill="' + ink + '" letter-spacing=".5">' + word + '</text>';
    return s;
  }

  // The white chrysanthemum: layers of curled petals, outer to inner.
  function flower(d, cx, cy, r, seed) {
    var rnd = rng(seed), fill = d.petal(), s = '<g>';
    s += '<circle cx="' + f(cx) + '" cy="' + f(cy) + '" r="' + f(r * 0.96) + '" fill="#e7e1da"/>';
    var layers = 7;
    for (var L = 0; L < layers; L++) {
      var R = r * (1 - L * 0.13), n = Math.max(9, Math.round(30 - L * 3)), len = R * (L < 2 ? 0.5 : 0.62), wid = len * (L < 2 ? 0.34 : 0.42);
      var off = rnd() * 360;
      for (var i = 0; i < n; i++) {
        var a = off + i * 360 / n + (rnd() - 0.5) * 9, lj = len * (0.85 + rnd() * 0.3), base = R - lj;
        s += '<path transform="translate(' + f(cx) + ' ' + f(cy) + ') rotate(' + f(a) + ') translate(0 ' + f(-base) + ')" d="M0 0C' + f(wid) + ' ' + f(-lj * 0.3) + ' ' + f(wid * 0.75) + ' ' + f(-lj * 0.88) + ' 0 ' + f(-lj) + 'C' + f(-wid * 0.75) + ' ' + f(-lj * 0.88) + ' ' + f(-wid) + ' ' + f(-lj * 0.3) + ' 0 0Z" fill="' + fill + '" stroke="#8a7f74" stroke-opacity=".22" stroke-width=".5"/>';
      }
    }
    s += '<circle cx="' + f(cx) + '" cy="' + f(cy) + '" r="' + f(r * 0.5) + '" fill="url(#' + d.id + 'fc)"/>';
    for (var k = 0; k < 7; k++) { var aa = k * 51; s += '<ellipse transform="translate(' + f(cx) + ' ' + f(cy) + ') rotate(' + aa + ')" cx="0" cy="' + f(-r * 0.06) + '" rx="' + f(r * 0.07) + '" ry="' + f(r * 0.12) + '" fill="#fff" stroke="#8a7f74" stroke-opacity=".2" stroke-width=".4"/>'; }
    return s + '</g>';
  }

  // The ring of looped ribbon around the flower. Each loop is a short folded
  // ribbon seen end-on; stripes mimic the edged and two-tone ribbon in the photos.
  function ring(d, cx, cy, r0, r1, n, cols, edge, seed) {
    var rnd = rng(seed), s = '<g>';
    for (var i = 0; i < n; i++) {
      var a = i * 360 / n, c = cols[i % cols.length], half = Math.PI * r1 / n * 1.08, inner = Math.PI * r0 / n * 1.0;
      var jr = r1 + (rnd() - 0.5) * 3;
      var p = 'M' + f(-inner) + ' ' + f(-r0) + 'L' + f(-half) + ' ' + f(-jr + half * 0.5) + 'Q' + f(-half) + ' ' + f(-jr - half * 0.35) + ' 0 ' + f(-jr - half * 0.35) + 'Q' + f(half) + ' ' + f(-jr - half * 0.35) + ' ' + f(half) + ' ' + f(-jr + half * 0.5) + 'L' + f(inner) + ' ' + f(-r0) + 'Z';
      s += '<path transform="translate(' + f(cx) + ' ' + f(cy) + ') rotate(' + f(a) + ')" d="' + p + '" fill="' + d.radial(c, 'ring') + '" stroke="' + mix(c, '#000000', 0.4) + '" stroke-opacity=".35" stroke-width=".6"/>';
      if (edge) s += '<path transform="translate(' + f(cx) + ' ' + f(cy) + ') rotate(' + f(a) + ')" d="M' + f(-half * 0.16) + ' ' + f(-r0) + 'L' + f(-half * 0.16) + ' ' + f(-jr - half * 0.3) + 'L' + f(half * 0.16) + ' ' + f(-jr - half * 0.3) + 'L' + f(half * 0.16) + ' ' + f(-r0) + 'Z" fill="' + edge + '" opacity=".95"/>';
    }
    return s + '</g>';
  }

  function rose(d, x, y, r, c, metal) {
    var dk = mix(c, '#000000', 0.42), lt = mix(c, '#ffffff', 0.28), s = '<g>';
    var base = metal ? d.metal(c) : d.satin(c);
    for (var i = 0; i < 5; i++) {
      s += '<path transform="translate(' + f(x) + ' ' + f(y) + ') rotate(' + (i * 72 + 18) + ')" d="M0 ' + f(-r * 0.15) + 'C' + f(r * 0.75) + ' ' + f(-r * 0.2) + ' ' + f(r * 0.7) + ' ' + f(-r * 1.02) + ' 0 ' + f(-r) + 'C' + f(-r * 0.7) + ' ' + f(-r * 1.02) + ' ' + f(-r * 0.75) + ' ' + f(-r * 0.2) + ' 0 ' + f(-r * 0.15) + 'Z" fill="' + base + '" stroke="' + dk + '" stroke-opacity=".55" stroke-width=".6"/>';
    }
    s += '<circle cx="' + f(x) + '" cy="' + f(y) + '" r="' + f(r * 0.62) + '" fill="' + c + '" stroke="' + dk + '" stroke-opacity=".5" stroke-width=".6"/>';
    s += '<path d="M' + f(x - r * 0.55) + ' ' + f(y + r * 0.05) + 'C' + f(x - r * 0.5) + ' ' + f(y - r * 0.6) + ' ' + f(x + r * 0.55) + ' ' + f(y - r * 0.6) + ' ' + f(x + r * 0.5) + ' ' + f(y + r * 0.1) + '" fill="none" stroke="' + lt + '" stroke-width="' + f(Math.max(0.7, r * 0.09)) + '"/>';
    s += '<path d="M' + f(x - r * 0.32) + ' ' + f(y + r * 0.22) + 'C' + f(x - r * 0.4) + ' ' + f(y - r * 0.32) + ' ' + f(x + r * 0.3) + ' ' + f(y - r * 0.38) + ' ' + f(x + r * 0.3) + ' ' + f(y + r * 0.05) + 'C' + f(x + r * 0.28) + ' ' + f(y + r * 0.3) + ' ' + f(x - r * 0.08) + ' ' + f(y + r * 0.3) + ' ' + f(x - r * 0.1) + ' ' + f(y + r * 0.02) + '" fill="none" stroke="' + dk + '" stroke-width="' + f(Math.max(0.7, r * 0.08)) + '" stroke-linecap="round"/>';
    return s + '</g>';
  }

  function daisy(d, x, y, r, c, rot) {
    var s = '<g transform="rotate(' + f(rot || 0) + ' ' + f(x) + ' ' + f(y) + ')">', dk = mix(c, '#000000', 0.25);
    for (var i = 0; i < 6; i++) s += '<path transform="translate(' + f(x) + ' ' + f(y) + ') rotate(' + (i * 60) + ')" d="M0 0C' + f(r * 0.38) + ' ' + f(-r * 0.35) + ' ' + f(r * 0.22) + ' ' + f(-r * 0.8) + ' 0 ' + f(-r) + 'C' + f(-r * 0.22) + ' ' + f(-r * 0.8) + ' ' + f(-r * 0.38) + ' ' + f(-r * 0.35) + ' 0 0Z" fill="' + d.satin(c) + '" stroke="' + dk + '" stroke-opacity=".5" stroke-width=".5"/>';
    s += '<circle cx="' + f(x) + '" cy="' + f(y) + '" r="' + f(r * 0.24) + '" fill="#FBF8F2" stroke="#C9C0B4" stroke-width=".5"/>';
    return s + '</g>';
  }

  function charm(d, x, y, r, c, metal, chainTop) {
    var s = '<path d="M' + f(x) + ' ' + f(chainTop) + 'L' + f(x) + ' ' + f(y - r) + '" stroke="' + metal + '" stroke-width="1" stroke-dasharray="1.6 1.2"/>';
    s += '<circle cx="' + f(x) + '" cy="' + f(y) + '" r="' + f(r) + '" fill="' + d.metal(metal) + '"/>';
    s += '<circle cx="' + f(x) + '" cy="' + f(y) + '" r="' + f(r * 0.78) + '" fill="' + mix(c, '#000000', 0.25) + '"/>';
    s += '<path d="M' + f(x - r * 0.42) + ' ' + f(y + r * 0.1) + 'L' + f(x) + ' ' + f(y - r * 0.45) + 'L' + f(x + r * 0.42) + ' ' + f(y + r * 0.1) + 'L' + f(x) + ' ' + f(y + r * 0.45) + 'Z" fill="' + mix(metal, '#ffffff', 0.35) + '" opacity=".85"/>';
    return s;
  }

  function bell(d, x, y, r) {
    var g = d.metal('#C9A227');
    return '<path d="M' + f(x - r) + ' ' + f(y + r * 0.8) + 'Q' + f(x - r) + ' ' + f(y - r) + ' ' + f(x) + ' ' + f(y - r) + 'Q' + f(x + r) + ' ' + f(y - r) + ' ' + f(x + r) + ' ' + f(y + r * 0.8) + 'Z" fill="' + g + '" stroke="#7a5a12" stroke-width=".6"/><circle cx="' + f(x) + '" cy="' + f(y + r * 0.95) + '" r="' + f(r * 0.28) + '" fill="#7a5a12"/>';
  }

  function butterfly(x, y, r, c, rot) {
    var w = '', edge = mix(c, '#000000', 0.35);
    [[-1, -1, 0.62, 0.5], [1, -1, 0.62, 0.5], [-1, 1, 0.42, 0.36], [1, 1, 0.42, 0.36]].forEach(function (q) {
      w += '<ellipse transform="rotate(' + (q[0] * q[1] * 28) + ' ' + f(x + q[0] * r * 0.5) + ' ' + f(y + q[1] * r * 0.32) + ')" cx="' + f(x + q[0] * r * 0.5) + '" cy="' + f(y + q[1] * r * 0.32) + '" rx="' + f(r * q[2]) + '" ry="' + f(r * q[3]) + '" fill="' + c + '" stroke="' + edge + '" stroke-width=".5"/>';
    });
    return '<g transform="rotate(' + f(rot) + ' ' + f(x) + ' ' + f(y) + ')">' + w + '<rect x="' + f(x - 0.6) + '" y="' + f(y - r * 0.6) + '" width="1.2" height="' + f(r * 1.2) + '" rx=".6" fill="' + edge + '"/></g>';
  }

  function monogram(d, cx, cy, r, c, metal, letters) {
    var t = String(letters || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3) || 'M';
    return '<circle cx="' + f(cx) + '" cy="' + f(cy) + '" r="' + f(r) + '" fill="#FBF8F2" stroke="' + metal + '" stroke-width="2.2"/><circle cx="' + f(cx) + '" cy="' + f(cy) + '" r="' + f(r * 0.82) + '" fill="none" stroke="' + c + '" stroke-width=".8"/><text x="' + f(cx) + '" y="' + f(cy + r * 0.24) + '" text-anchor="middle" font-family="Georgia,serif" font-size="' + f(r * (t.length > 1 ? 0.62 : 0.85)) + '" fill="' + c + '">' + t + '</text>';
  }

  function nextGradYear() { var d = new Date(); return d.getFullYear() + (d.getMonth() >= 6 ? 1 : 0); } // grads finish in spring

  function boxStyle(o) {
    return 'display:block;width:100%;height:auto;max-width:' + (o.maxWidth || 240) + 'px;' + (o.maxHeight ? 'max-height:' + o.maxHeight + 'px;' : '') + 'margin:0 auto;';
  }

  // ---------- package tables (visual only) ----------
  var MUM = {
    'petite mum': { flower: 4.5, skirt: 8, braids: 1, name: false },
    'mini mum': { flower: 4.5, skirt: 12, braids: 1, name: false },
    'deluxe mini': { flower: 4.5, skirt: 14, braids: 2, name: 'rhinestone' },
    'classic single': { flower: 6.5, skirt: 30, braids: 2, name: true },
    // Names before the Oct 2026 price update, kept so older links still draw.
    'deluxe petite': { flower: 4.5, skirt: 14, braids: 2, name: 'rhinestone' },
    'standard single': { flower: 6.5, skirt: 30, braids: 2, name: true },
    'deluxe single': { flower: 6.5, skirt: 30, braids: 3, name: 'rhinestone', hoco: 'rhinestone', roses: true },
    'senior mum': { flower: 7.5, skirt: 36, braids: 4, name: true, senior: true, roses: true },
    'deluxe senior': { flower: 7.5, skirt: 36, braids: 5, name: 'rhinestone', senior: true, roses: true, monogram: true },
    'custom mum': { flower: 7.5, skirt: 36, braids: 4, name: true, roses: true }
  };
  var GARTER = {
    'petite garter': { flower: 4.5, skirt: 6, braids: 1 },
    'mini garter': { flower: 4.5, skirt: 8, braids: 2 },
    'classic garter': { flower: 6.5, skirt: 18, braids: 3 },
    'senior garter': { flower: 7.5, skirt: 22, braids: 4, name: true, senior: true },
    'deluxe senior garter': { flower: 7.5, skirt: 24, braids: 5, name: 'rhinestone', senior: true, monogram: true },
    'custom garter': { flower: 6.5, skirt: 20, braids: 3, name: true }
  };
  var BRAID_KEYS = { 'single military': 'single', 'double military': 'double', 'single ruffle': 'ruffle', 'double ruffle': 'druffle', 'box braid': 'box', 'whip braid': 'whip', 'texas chain': 'texas', 'diamond back': 'diamond', 'triangle': 'triangle', 'triple loop': 'triple', 'single ribbon loop': 'loop', 'heart chain': 'heart', 'mobius': 'mobius' };
  var DEFAULT_BRAIDS = ['single', 'loop', 'box', 'double', 'texas', 'triple'];

  function pkgSpec(table, name, fallback) {
    var k = String(name || '').toLowerCase().replace(/\s*·.*$/, '').trim();
    return table[k] || table[fallback];
  }

  // ---------- mum / garter ----------
  function piece(o, isGarter) {
    o = o || {};
    var spec = pkgSpec(isGarter ? GARTER : MUM, o.package, isGarter ? 'classic garter' : 'classic single');
    var pal = palette(o.colors), id = 'bba' + (uid++), d = new Defs(id);
    var flowerIn = o.flower || spec.flower, skirtIn = spec.skirt + (o.extraLength || 0);
    var rf = { 4.5: 34, 6.5: 41, 7.5: 45, 9: 51 }[flowerIn] || 41;
    var ringW = flowerIn >= 6.5 ? 22 : 17, ro = rf + ringW;
    var W = 300, cx = W / 2, cy = ro + 16;
    var L = Math.round(30 + skirtIn * 7.5); // visible skirt below the crown, roughly to scale
    var top = cy + rf * 0.2, vis = cy + ro * 0.86, bottom = vis + L, H = Math.ceil(bottom + 18);
    var rnd = rng(7 + Math.round(flowerIn * 10) + skirtIn);
    var span = Math.min(ro * 2.1, 220), x0 = cx - span / 2, reach = vis - top; // reach: hidden part behind the crown
    var s = '';

    // back layer: wide satin ribbons fanning out under the crown
    var backCols = [pal.p, '#FFFFFF', pal.s, pal.p, pal.metal, pal.s, '#FFFFFF', pal.p];
    var nBack = Math.max(6, Math.round(span / 19));
    var back = '';
    for (var i = 0; i < nBack; i++) {
      var w = 26 + rnd() * 8, x = x0 + i * (span - 26) / (nBack - 1), c = backCols[i % backCols.length];
      var len = reach + L * (0.84 + rnd() * 0.16) - (i === 0 || i === nBack - 1 ? 12 : 0), rot = (i - (nBack - 1) / 2) * (isGarter ? 2.6 : 2.1);
      back += ribbon(d, x, top, w, len, c, { rot: rot, metal: c === pal.metal, glitter: c === pal.metal, edge: c === pal.p && i % 2 ? pal.metal : null });
    }
    // middle layer: narrower ribbons in contrast colors
    var mid = '', nMid = nBack;
    for (i = 0; i < nMid; i++) {
      var w2 = 12 + rnd() * 6, x2 = x0 + 14 + i * (span - 40) / Math.max(1, nMid - 1), c2 = [pal.s, pal.p, '#FFFFFF', pal.t][i % 4];
      mid += ribbon(d, x2, top + 6, w2, reach + L * (0.72 + rnd() * 0.22), c2, { rot: (i - nMid / 2) * 1.6, cut: i % 3 === 1 ? 'angle' : 'v', stripe: i % 2 ? pal.metal : null, stripeW: 1.6 });
    }
    // front layer: braids, name and word ribbons, evenly across the skirt
    var braids = (o.braids && o.braids.length) ? o.braids.slice() : [];
    var nb = spec.braids; while (braids.length < nb) braids.unshift(DEFAULT_BRAIDS[(braids.length) % DEFAULT_BRAIDS.length]);
    braids = braids.slice(0, isGarter ? 5 : 7);
    var fronts = [];
    braids.forEach(function (b, k) { fronts.push({ kind: 'braid', style: b, k: k }); });
    var nameKind = o.lettering || (spec.name === 'rhinestone' ? 'rhinestone' : '');
    var names = (o.names || []).map(function (x) { return String(x || '').trim(); }).filter(Boolean).slice(0, 3);
    if (!names.length && o.name) names = [o.name];
    if (!names.length && spec.name) names = [''];
    names.forEach(function (nm, k) {
      var at = Math.min(fronts.length, Math.floor((k + 1) * (fronts.length + 1) / (names.length + 1)));
      fronts.splice(at, 0, { kind: 'name', lettering: nameKind, text: nm });
    });
    if (!isGarter && skirtIn >= 12) fronts.splice(Math.ceil(fronts.length / 2) + 1, 0, { kind: 'word', word: spec.hoco ? 'Homecoming' : 'Homecoming', bright: !!spec.hoco });
    if (spec.senior) fronts.splice(1, 0, { kind: 'word', word: 'Senior', bright: true });
    var nF = fronts.length, fSpan = span - 22, front = '';
    fronts.forEach(function (it, k) {
      var fw = it.kind === 'braid' ? 20 : 23, fx = cx - fSpan / 2 + (nF === 1 ? fSpan / 2 : k * fSpan / (nF - 1)) - fw / 2;
      var flen = L * (0.74 + ((k * 37) % 21) / 100), ftop = it.kind === 'braid' ? vis - 8 + (k % 2) * 5 : cy + ro + 2;
      if (it.kind !== 'braid') flen -= (cy + ro + 2) - (vis - 8);
      if (it.kind === 'braid') front += braid(d, it.style, fx, ftop, fw, flen, k % 2 ? pal.s : pal.p, k % 2 ? pal.p : (isWhitish(pal.s) ? pal.metal : pal.s), pal.metal);
      else if (it.kind === 'name') front += nameRibbon(d, fx, ftop, fw, flen, isWhitish(pal.p) ? pal.s : '#FFFFFF', it.text, it.lettering, pal.p);
      else front += wordRibbon(d, fx, ftop, fw - 2, flen * 0.9, it.bright ? pal.p : '#FFFFFF', it.word, it.bright ? (isWhitish(pal.s) ? '#FFFFFF' : pal.s) : pal.p);
    });

    s += '<g filter="url(#' + id + 'sh)">' + back + mid + front + '</g>';

    // butterflies scattered on the skirt
    var nbf = Math.min(o.butterflies || 0, 10), br = rng(99);
    var bfl = '';
    for (i = 0; i < nbf; i++) bfl += butterfly(x0 + 12 + br() * (span - 24), vis + 30 + br() * (L * 0.62), 5.2, i % 2 ? pal.s : pal.metal, br() * 60 - 30);

    // crown: ring (two rows on bigger flowers), flower, center
    var crown = '';
    var ringCols = isWhitish(pal.s) ? [pal.p, '#FFFFFF'] : [pal.p, pal.s];
    if (ringW > 18) crown += ring(d, cx, cy, rf - 2, ro, 30, ringCols.slice().reverse(), null, 11);
    crown += ring(d, cx, cy, rf - 4, ro - (ringW > 18 ? 8 : 0), ringW > 18 ? 26 : 24, [pal.p], pal.metal === '#B9BEC4' ? (isWhitish(pal.s) ? '#FFFFFF' : pal.s) : pal.metal, 21);
    crown += flower(d, cx, cy, rf, 5);
    if (spec.monogram) crown += monogram(d, cx, cy, rf * 0.42, pal.p, pal.metal, o.monogram || names[0] || o.name);
    if (spec.roses || o.roses) {
      var rr = Math.max(11, rf * 0.33), rc = isWhitish(pal.s) ? pal.metal : pal.s;
      crown += rose(d, cx + ro * 0.95, cy + ro * 0.18, rr * 0.9, rc) + rose(d, cx + ro * 0.8, cy + ro * 0.62, rr, rc) + rose(d, cx + ro * 0.45, cy + ro * 0.9, rr * 0.88, rc);
    }
    s += '<g filter="url(#' + id + 'sh)">' + crown + '</g>';

    // charms on chains and the brass bell, hanging just below the crown
    var nCharms = Math.min(1 + (o.charmChains || 0), 4), chs = '';
    for (i = 0; i < nCharms; i++) {
      var chx = cx - ro * 0.78 + i * 17, chTop = cy + ro * 0.8, chy = chTop + 20 + (i % 2) * 13;
      chs += charm(d, chx, chy, 8.5, i % 2 ? pal.s : pal.p, pal.metal, chTop);
    }
    chs += bell(d, cx + (spec.roses ? -ro * 0.85 : ro * 0.7), cy + ro * 0.72, 6);
    if (o.disc) chs += charm(d, cx + ro * 0.15, cy + ro * 1.1, o.disc === 3 ? 11 : 9, pal.p, pal.metal, cy + ro * 0.85);
    s += '<g filter="url(#' + id + 'sh)">' + chs + bfl + '</g>';

    return '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Preview of your ' + (isGarter ? 'garter' : 'mum') + '" style="' + boxStyle(o) + '">' + d.out() + s + '</svg>';
  }

  // ---------- lei ----------
  var LEI = {
    'basic lei': { flowers: false }, 'classic lei': { flowers: true }, 'grad lei': { flowers: true, tassel: true, charms: true },
    'deluxe lei': { flowers: true, tassel: true, charms: true, names: true }, 'design your own': { flowers: true }
  };
  function lei(o) {
    o = o || {};
    var spec = pkgSpec(LEI, o.package, 'classic lei'), id = 'bbl' + (uid++), d = new Defs(id);
    var cs = (o.colors || []).filter(Boolean); if (!cs.length) cs = ['#7A1F2B', '#C9A227', '#FFFFFF'];
    var W = 240, H = 270, s = '';
    // the strand: a V that hangs from the shoulders to a point
    function bez(p0, p1, p2, p3, t) { var u = 1 - t; return [u * u * u * p0[0] + 3 * u * u * t * p1[0] + 3 * u * t * t * p2[0] + t * t * t * p3[0], u * u * u * p0[1] + 3 * u * u * t * p1[1] + 3 * u * t * t * p2[1] + t * t * t * p3[1]]; }
    var A = [[46, 16], [38, 120], [92, 196], [120, 226]], B = [[194, 16], [202, 120], [148, 196], [120, 226]];
    var segs = [], N = 44;
    [A, B].forEach(function (P, side) {
      for (var i = 0; i <= N; i++) {
        var t = i / N, p = bez(P[0], P[1], P[2], P[3], t), q = bez(P[0], P[1], P[2], P[3], Math.min(1, t + 0.01)), a = Math.atan2(q[1] - p[1], q[0] - p[0]) * 180 / Math.PI;
        segs.push({ x: p[0], y: p[1], a: a, i: i, side: side, t: t });
      }
    });
    // braided satin: overlapping folds that alternate left and right, cycling the colors
    var strand = '';
    segs.forEach(function (g) {
      var c = cs[g.i % cs.length], lean = g.i % 2 ? 38 : -38;
      strand += '<path transform="translate(' + f(g.x) + ' ' + f(g.y) + ') rotate(' + f(g.a + lean) + ')" d="M-11 0C-8 -6.5 8 -6.5 11 0C8 6.5 -8 6.5 -11 0Z" fill="' + d.satin(c) + '" stroke="' + mix(c, '#000000', 0.4) + '" stroke-opacity=".5" stroke-width=".6"/>';
    });
    s += '<g filter="url(#' + id + 'sh)">' + strand + '</g>';
    var extras = '';
    if (spec.tassel) {
      var tc = cs[0];
      extras += '<rect x="113" y="226" width="14" height="7" rx="2" fill="' + d.metal('#C9A227') + '"/>';
      for (var k = 0; k < 9; k++) extras += '<rect x="' + f(113 + k * 1.6) + '" y="232" width="1.2" height="30" fill="' + mix(tc, '#000000', k % 2 ? 0.1 : 0.3) + '"/>';
      extras += '<circle cx="120" cy="224" r="5" fill="' + d.metal('#C9A227') + '"/>';
    }
    if (spec.names) {
      extras += nameRibbon(d, 84, 214, 13, 46, '#FFFFFF', o.name || 'GRAD', 'rhinestone', cs[0]);
      extras += wordRibbon(d, 143, 214, 13, 46, cs[0], String(o.year || nextGradYear()), isWhitish(cs[1] || '#fff') ? '#FFFFFF' : (cs[1] || '#FFFFFF'));
    }
    if (spec.flowers) {
      // 6 roses and 12 daisies along the front: daisy, daisy, rose down each side
      var rc = cs[1 % cs.length], dc = cs.length > 2 ? cs[2] : '#FFFFFF';
      [0, 1].forEach(function (side) {
        var pts = segs.filter(function (g) { return g.side === side && g.t > 0.36 && g.t < 0.97; });
        for (var j = 0; j < 9; j++) {
          var g = pts[Math.round(j * (pts.length - 1) / 8)];
          extras += j % 3 === 2 ? rose(d, g.x, g.y, 9.5, rc) : daisy(d, g.x + (j % 2 ? 2 : -2), g.y, 8.5, dc, g.a + j * 17);
        }
      });
    }
    if (spec.charms) extras += charm(d, 120, 250, 0, cs[0], '#C9A227', 250) + '<circle cx="104" cy="212" r="5.5" fill="' + d.metal('#C9A227') + '"/><circle cx="136" cy="212" r="5.5" fill="' + d.metal('#C9A227') + '"/>';
    s += '<g filter="url(#' + id + 'sh)">' + extras + '</g>';
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Preview of your lei" style="' + boxStyle(o) + '">' + d.out() + s + '</svg>';
  }

  root.BBArt = {
    mum: function (o) { return piece(o, false); },
    garter: function (o) { return piece(o, true); },
    lei: lei,
    braidKey: function (label) { return BRAID_KEYS[String(label || '').toLowerCase().replace(/^braid\s*·\s*/, '').replace(/\s*·.*$/, '').trim()] || null; }
  };
})(window);
